/* Happilystory — fiche "poster-monde" : MOTEUR GENERIQUE de personnalisation.

   Meme pattern d'impression que poster-naissance (canvas transparent par palette
   + overlay <text> 2400x3200 + worker _hs_mode=grid), mais AUCUNE clé de champ
   n'est codée en dur : le formulaire est GENERE à partir de config.fields
   (metafield happilystory.monde_config), et slotValue(key) lit le champ portant
   cette clé. Ajouter "plat préféré" ou "métier rêvé" à une collection = éditer le
   manifest, pas ce fichier.

   Contrat d'impression STRICTEMENT identique à poster-naissance :
     _hs_mode=grid, _hs_canvas_url, _hs_bg, _hs_ink, _hs_grid (JSON
     [{x,y,size,text,anchor,family,fill}] avec textes finalisés + x déjà corrigé
     de l'écart optique Caveat), _hs_sig_y, _hs_format, _hs_cadre,
     _hs_nowatermark. Le worker shopify-to-gelato n'est PAS modifié.
*/
(function () {
  var CFG = window.HSP_CFG || {};
  var N = CFG.monde || null;
  var root = document.querySelector('[data-section-id="' + CFG.sectionId + '"]');
  if (!root) return;
  var form = root.querySelector('.hsp-form');
  if (!form) return;

  function warn(msg) { if (window.console && console.warn) console.warn('[happilystory][monde] ' + msg); }

  // Garde-fou production : sans config exploitable, la fiche ne doit PAS pouvoir
  // envoyer au panier une affiche sans personnalisation ni payload print (le
  // formulaire natif partirait sans _hs_grid -> commande impossible à imprimer).
  function abortEngine(msg) {
    warn(msg);
    var btn = form.querySelector('.hsp-add-to-cart');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); }
    var note = form.querySelector('[data-monde-error]');
    if (note) note.hidden = false;
  }
  if (!N || typeof N !== 'object' || !Array.isArray(N.fields) || !N.fields.length ||
      !Array.isArray(N.slots) || !N.slots.length) {
    abortEngine('metafield happilystory.monde_config absent ou invalide (fields[] et slots[] requis).');
    return;
  }

  var WATERMARK_VARIANT_ID = 62562593964362;
  var WATERMARK_PRICE_CENTS = 299;

  var VARIANTS = CFG.variants || [];
  var CANVAS_BY_PALETTE = CFG.canvasByPalette || {};
  var PALETTES = Object.create(null);
  (N.palettes || []).forEach(function (p) { if (p && p.id) PALETTES[p.id] = p; });
  var curPalette = (CFG.defaultPalette && PALETTES[CFG.defaultPalette]) ? CFG.defaultPalette
    : (N.defaultPalette && PALETTES[N.defaultPalette]) ? N.defaultPalette
    : (N.palettes && N.palettes[0] ? N.palettes[0].id : null);
  var INK = N.ink || '#4A3B3F';
  // Position Y de la signature happilystory (parité aperçu / print).
  var SIG_Y = (Number(N.sigY) > 0) ? Number(N.sigY) : 3120;

  // Compensation optique de centrage : Caveat est une manuscrite PENCHÉE, ses
  // glyphes ne sont pas centrés dans leur avance. Un text-anchor="middle"
  // (qui centre l'avance, pas l'encre) pose donc le texte ~10 % de la taille
  // trop à DROITE — visible car le libellé cuit juste au-dessus est en
  // Quicksand, qui se centre parfaitement. On décale les textes Caveat.
  // Le x corrigé part tel quel dans _hs_grid : l'impression hérite du fix.
  var OPTICAL_DX_RATIO = { Caveat: -0.10 };
  function opticalDx(family, size) {
    var r = OPTICAL_DX_RATIO[family];
    return r ? Math.round(r * size) : 0;
  }

  // Le TTF print attend le family-name front ; textElGrid (worker) traduit déjà
  // Fredoka -> "Fredoka SemiBold", on envoie donc la clé front telle quelle.
  var CSS_FAMILY = {
    'Caveat': "'Caveat', cursive",
    'Quicksand': "'Quicksand', sans-serif",
    'Fredoka': "'Fredoka', sans-serif",
    'Pacifico': "'Pacifico', cursive",
    'Amatic SC': "'Amatic SC', cursive"
  };
  // Graisse d'aperçu = graisse du TTF que le worker charge pour cette famille
  // (FONT_FILES : Caveat-Bold, Fredoka-SemiBold, Pacifico-Regular,
  // AmaticSC-Bold, Quicksand-Bold). L'auto-fit mesure donc la MEME densité de
  // texte que celle qui sera imprimée — sinon un texte mesuré en Regular puis
  // imprimé en Bold déborde de maxw.
  var CSS_WEIGHT = {
    'Caveat': 700,
    'Quicksand': 700,
    'Fredoka': 600,
    'Pacifico': 400,
    'Amatic SC': 700
  };

  function lightenHex(hex, amount) {
    var m = /^#([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return '#b9b1a6';
    var n = parseInt(m[1], 16);
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    function h2(v) { return ('0' + v.toString(16)).slice(-2); }
    r = Math.round(r + (255 - r) * amount);
    g = Math.round(g + (255 - g) * amount);
    b = Math.round(b + (255 - b) * amount);
    return '#' + h2(r) + h2(g) + h2(b);
  }

  // =========================================================================
  // 1. CHAMPS : normalisation de config.fields
  // =========================================================================
  var TEXT_MAXLENGTH_FALLBACK = 30;
  var SUPPORTED_TYPES = { text: 1, number: 1, date: 1, time: 1 };

  var FIELDS = [];                          // ordre d'affichage = ordre du manifest
  // Prototype nul : les clés viennent du manifest, une clé "constructor" ou
  // "toString" ne doit pas hériter d'une valeur d'Object.prototype.
  var FIELD_BY_KEY = Object.create(null);   // key -> définition normalisée

  N.fields.forEach(function (f) {
    if (!f || typeof f !== 'object' || !f.key) { warn('champ ignoré (objet sans "key").'); return; }
    var key = String(f.key);
    if (FIELD_BY_KEY[key]) { warn('clé de champ dupliquée "' + key + '" — seule la première est gardée.'); return; }

    var type = String(f.type || 'text').toLowerCase();
    if (!SUPPORTED_TYPES[type]) {
      warn('type "' + f.type + '" inconnu pour le champ "' + key + '" — traité en texte.');
      type = 'text';
    }

    var maxlength = 0;
    if (type === 'text') {
      maxlength = parseInt(f.maxlength, 10);
      if (!(maxlength > 0)) {
        warn('champ "' + key + '" : maxlength manquant (obligatoire pour un type text) — repli sur ' + TEXT_MAXLENGTH_FALLBACK + '.');
        maxlength = TEXT_MAXLENGTH_FALLBACK;
      }
    }

    var def = {
      key: key,
      label: String(f.label || key),
      type: type,
      maxlength: maxlength,
      placeholder: (f.placeholder != null) ? String(f.placeholder) : '',
      sample: (f.sample != null) ? String(f.sample) : '',
      suffix: (f.suffix != null) ? String(f.suffix) : '',
      hint: (f.hint != null) ? String(f.hint) : '',
      required: f.required === true,
      min: (f.min != null && f.min !== '') ? String(f.min) : '',
      max: (f.max != null && f.max !== '') ? String(f.max) : '',
      step: (f.step != null && f.step !== '') ? String(f.step) : '',
      inputmode: (f.inputmode != null) ? String(f.inputmode) : '',
      // Un champ long occupe toute la largeur de la grille (2 colonnes desktop).
      wide: (f.wide === true) || (type === 'text' && maxlength >= 20)
    };
    FIELDS.push(def);
    FIELD_BY_KEY[key] = def;
  });

  if (!FIELDS.length) {
    abortEngine('aucun champ exploitable dans monde_config.fields.');
    return;
  }

  // Deux champs qui portent le MÊME libellé écraseraient la même property panier.
  (function checkLabels() {
    var seen = Object.create(null);
    FIELDS.forEach(function (f) {
      if (seen[f.label]) warn('libellé "' + f.label + '" utilisé par 2 champs (' + seen[f.label] + ' / ' + f.key + ') — la property panier sera écrasée.');
      else seen[f.label] = f.key;
      if (f.label.charAt(0) === '_') warn('libellé "' + f.label + '" commençant par "_" : Shopify le masquera dans le panier.');
    });
  })();

  // Slots valides = objets avec une clé DECLAREE dans fields (contrat SPEC-MONDE).
  // Les coordonnées sont COERCEES en nombres : un "x": "1200" (chaîne) au manifest
  // ferait une concaténation au moment du décalage optique ("1200-15") et partirait
  // tel quel dans _hs_grid -> affiche imprimée hors du support.
  function num(v, fallback) {
    var n = Number(v);
    return isFinite(n) ? n : fallback;
  }
  var SLOTS = [];
  N.slots.forEach(function (s) {
    if (!s || typeof s !== 'object' || !s.key) { warn('slot ignoré (objet sans "key").'); return; }
    if (!FIELD_BY_KEY[s.key]) {
      warn('slot "' + s.key + '" sans champ correspondant dans fields — il ne serait jamais rempli, il est ignoré.');
      return;
    }
    if (!(Number(s.maxw) > 0)) warn('slot "' + s.key + '" sans maxw : un texte libre long débordera du support.');
    if (s.family && !CSS_FAMILY[s.family]) warn('slot "' + s.key + '" : police "' + s.family + '" hors des 5 fontes print — repli sur Caveat.');
    SLOTS.push({
      key: String(s.key),
      x: num(s.x, 1200),
      y: num(s.y, 1600),
      size: num(s.size, 100),
      anchor: (s.anchor === 'start' || s.anchor === 'end') ? s.anchor : 'middle',
      family: (s.family && CSS_FAMILY[s.family]) ? String(s.family) : 'Caveat',
      fill: (typeof s.fill === 'string' && s.fill) ? s.fill : INK,
      maxw: num(s.maxw, 0),
      letterSpacing: (s.letterSpacing != null && s.letterSpacing !== '') ? s.letterSpacing : null,
      sample: (s.sample != null) ? String(s.sample) : ''
    });
  });
  if (!SLOTS.length) {
    abortEngine('aucun slot exploitable (toutes les clés de slots sont absentes de fields).');
    return;
  }

  // =========================================================================
  // 2. FORMULAIRE : génération des champs depuis FIELDS
  // =========================================================================
  var fieldsWrap = form.querySelector('[data-monde-fields]');
  if (!fieldsWrap) {
    // Sans conteneur, aucun champ ne serait généré : on ne laisse pas partir
    // au panier une affiche vide de personnalisation.
    abortEngine('conteneur [data-monde-fields] introuvable dans la section.');
    return;
  }
  var fieldsLabelEl = form.querySelector('[data-monde-fields-label]');
  if (fieldsLabelEl) fieldsLabelEl.textContent = N.fieldsLabel || 'Les informations à imprimer';

  var inputByKey = Object.create(null);   // key -> <input>
  var countByKey = Object.create(null);   // key -> <span> compteur de caractères

  function buildField(f) {
    var wrap = document.createElement('label');
    wrap.className = 'hsp-mfield' + (f.wide ? ' hsp-mfield--wide' : '');
    wrap.setAttribute('data-mfield', f.key);

    var head = document.createElement('span');
    head.className = 'hsp-mfield__head';

    var lab = document.createElement('span');
    lab.className = 'hsp-mfield__label';
    lab.textContent = f.label;
    head.appendChild(lab);

    // Indicateur discret à droite du libellé : compteur (text) ou bornes (number).
    if (f.type === 'text' && f.maxlength) {
      var cnt = document.createElement('span');
      cnt.className = 'hsp-mfield__count';
      cnt.setAttribute('aria-hidden', 'true');
      cnt.textContent = '0/' + f.maxlength;
      head.appendChild(cnt);
      countByKey[f.key] = cnt;
    } else if (f.type === 'number' && (f.min !== '' || f.max !== '')) {
      var bounds = document.createElement('span');
      bounds.className = 'hsp-mfield__count';
      bounds.setAttribute('aria-hidden', 'true');
      bounds.textContent = (f.min !== '' ? f.min : '…') + ' – ' + (f.max !== '' ? f.max : '…');
      head.appendChild(bounds);
    }
    wrap.appendChild(head);

    var input = document.createElement('input');
    input.className = 'hsp-input hsp-mfield__input';
    input.setAttribute('data-source', f.key);
    // name = repli si le JS de soumission ne prend pas la main (la valeur réelle
    // envoyée au panier est construite en JSON plus bas, avec suffixe/format).
    input.name = 'properties[' + f.label + ']';
    input.setAttribute('aria-label', f.label);
    input.autocomplete = 'off';
    if (f.required) input.required = true;

    if (f.type === 'text') {
      input.type = 'text';
      input.maxLength = f.maxlength;
      if (f.placeholder) input.placeholder = f.placeholder;
      if (f.inputmode) input.setAttribute('inputmode', f.inputmode);
    } else if (f.type === 'number') {
      input.type = 'number';
      input.setAttribute('inputmode', f.inputmode || 'numeric');
      if (f.min !== '') input.min = f.min;
      if (f.max !== '') input.max = f.max;
      if (f.step !== '') input.step = f.step;
      if (f.placeholder) input.placeholder = f.placeholder;
    } else if (f.type === 'date') {
      input.type = 'date';
    } else if (f.type === 'time') {
      input.type = 'time';
    }
    wrap.appendChild(input);
    inputByKey[f.key] = input;

    if (f.hint) {
      var hint = document.createElement('span');
      hint.className = 'hsp-mfield__hint';
      hint.textContent = f.hint;
      wrap.appendChild(hint);
    }
    return wrap;
  }

  FIELDS.forEach(function (f) { fieldsWrap.appendChild(buildField(f)); });
  fieldsWrap.hidden = false;

  function updateCount(f) {
    var cnt = countByKey[f.key];
    var input = inputByKey[f.key];
    if (!cnt || !input) return;
    var len = String(input.value || '').length;
    cnt.textContent = len + '/' + f.maxlength;
    cnt.classList.toggle('is-max', len >= f.maxlength);
  }
  function updateAllCounts() { FIELDS.forEach(updateCount); }

  // =========================================================================
  // 3. OVERLAY : un <text> par slot (index-aligné avec SLOTS)
  // =========================================================================
  var overlay = root.querySelector('.hsp-overlay');
  var SVG_NS = 'http://www.w3.org/2000/svg';
  // Tableau PARALLELE à SLOTS (et non map par clé) : un même champ peut
  // alimenter plusieurs slots (SPEC-MONDE §1), chacun avec sa propre taille
  // auto-fit et son propre décalage optique.
  var slotEls = [];
  SLOTS.forEach(function (s) {
    var t = document.createElementNS(SVG_NS, 'text');
    t.setAttribute('x', s.x);
    t.setAttribute('y', s.y);
    t.setAttribute('text-anchor', s.anchor || 'middle');
    t.setAttribute('font-size', s.size);
    t.setAttribute('fill', s.fill || INK);
    t.style.fontFamily = CSS_FAMILY[s.family] || CSS_FAMILY['Caveat'];
    t.style.fontWeight = CSS_WEIGHT[s.family] || CSS_WEIGHT['Caveat'];
    if (s.letterSpacing) t.setAttribute('letter-spacing', s.letterSpacing);
    if (overlay) overlay.appendChild(t);
    slotEls.push({ el: t, def: s, fitted: s.size, dx: 0 });
  });

  // Signature happilystory dans l'aperçu (parité print : signatureSvg worker,
  // Caveat 56, opacity .4, encre du design). Masquée si upsell watermark.
  var sigEl = document.createElementNS(SVG_NS, 'text');
  sigEl.setAttribute('x', 1200);
  sigEl.setAttribute('y', SIG_Y);
  sigEl.setAttribute('text-anchor', 'middle');
  sigEl.setAttribute('font-size', 56);
  sigEl.setAttribute('letter-spacing', 10);
  sigEl.setAttribute('opacity', '0.4');
  sigEl.setAttribute('fill', INK);
  sigEl.style.fontFamily = CSS_FAMILY['Caveat'];
  sigEl.style.fontWeight = CSS_WEIGHT['Caveat'];
  sigEl.textContent = 'happilystory';
  if (overlay) overlay.appendChild(sigEl);

  // Auto-fit : réduit la taille si le texte déborde de slot.maxw (textes libres).
  function fitSlot(entry) {
    var el = entry.el, s = entry.def;
    var maxw = Number(s.maxw) || 0;
    el.setAttribute('font-size', s.size);
    entry.fitted = s.size;
    if (maxw) {
      try {
        var w = el.getComputedTextLength();
        if (w > maxw) {
          var next = Math.max(40, Math.floor(s.size * maxw / w));
          el.setAttribute('font-size', next);
          entry.fitted = next;
        }
      } catch (e) { /* getComputedTextLength indispo (élément caché) : garde size */ }
    }
    // Recentrage optique une fois la taille finale connue.
    entry.dx = opticalDx(s.family || 'Caveat', entry.fitted);
    el.setAttribute('x', s.x + entry.dx);
  }

  // =========================================================================
  // 4. VALEURS : formatage générique piloté par la déclaration du champ
  // =========================================================================
  function fmtDate(val) { // input date "2025-03-12" -> "12.03.2025"
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(val || '');
    if (!m) return '';
    return pad2(m[3]) + '.' + pad2(m[2]) + '.' + m[1];
  }
  function fmtTime(val) { // input time "08:42" (ou "08:42:00") -> "08h42"
    var m = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(val || '');
    if (!m) return '';
    return pad2(m[1]) + 'h' + m[2];
  }
  function pad2(v) { return ('0' + String(v)).slice(-2); }

  function escapeRe(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  // Le suffixe est un habillage d'AFFICHAGE : le client tape "6", l'affiche
  // montre "6 ans". S'il a quand même tapé l'unité, on ne la double pas.
  // Le caractère qui précède l'unité ne doit pas être une lettre, sinon un
  // suffixe " m" considérerait "Boum" comme déjà suffixé ("51cm" reste OK).
  function applySuffix(v, suffix) {
    if (!suffix) return v;
    var tail = String(suffix).trim();
    if (tail && new RegExp('(^|[^A-Za-zÀ-ÿ])' + escapeRe(tail) + '\\s*$', 'i').test(v)) return v;
    // Accord au singulier : « 1 ans » est une faute qui partirait à l'impression.
    // Une valeur strictement égale à 1 dépluralise le suffixe (" ans" -> " an").
    if (/^0*1([.,]0+)?$/.test(v) && /s$/i.test(suffix)) return v + suffix.replace(/s$/i, '');
    return v + suffix;
  }

  function formatValue(f, raw) {
    var v = String(raw == null ? '' : raw).trim();
    if (!v) return '';
    if (f.type === 'date') return fmtDate(v);
    if (f.type === 'time') return fmtTime(v);
    return applySuffix(v, f.suffix);
  }

  // AUCUNE cascade de "if" par clé : la valeur d'un slot = la valeur du champ
  // qui porte la même clé, formatée selon la déclaration de ce champ.
  function slotValue(key) {
    var f = FIELD_BY_KEY[key];
    if (!f) return '';
    var el = inputByKey[key];
    return formatValue(f, el ? el.value : '');
  }

  // Exemple estompé quand le champ est vide : slot.sample > field.sample >
  // surcharge du toggle (genders). Un slot sans exemple reste vide (SPEC-MONDE :
  // "prévoir le champ vide").
  var sampleOverride = Object.create(null);
  function sampleFor(s) {
    var f = FIELD_BY_KEY[s.key];
    var raw;
    if (Object.prototype.hasOwnProperty.call(sampleOverride, s.key)) raw = sampleOverride[s.key];
    else if (s.sample != null && s.sample !== '') raw = String(s.sample);
    else raw = (f && f.sample) ? f.sample : '';
    // L'exemple estompé doit être formaté comme la vraie valeur : sans ça
    // l'aperçu montre « 6 » avant saisie puis « 7 ans » après, ce qui laisse
    // croire que le suffixe est du texte tapé par le client.
    // Repli sur le brut : un sample de date déjà écrit en clair (12.03.2025)
    // ne repasse pas le parseur ISO et serait sinon vidé.
    if (!raw) return '';
    return formatValue(f || {}, raw) || raw;
  }

  function render() {
    for (var i = 0; i < slotEls.length; i++) {
      var entry = slotEls[i];
      var s = entry.def;
      var v = slotValue(s.key);
      var sample = sampleFor(s);
      entry.el.textContent = v || sample;
      entry.el.setAttribute('fill', v ? (s.fill || INK) : lightenHex(s.fill || INK, 0.45));
      fitSlot(entry);
    }
  }

  FIELDS.forEach(function (f) {
    var el = inputByKey[f.key];
    if (!el) return;
    ['input', 'change'].forEach(function (ev) {
      el.addEventListener(ev, function () { updateCount(f); render(); });
    });
  });
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { render(); }); }

  // =========================================================================
  // 5. Palette (canvas + fond couplés) — identique à poster-naissance
  // =========================================================================
  var baseImg = root.querySelector('.hsp-product-base');
  var bgLayer = root.querySelector('[data-bg-layer]');
  var canvasWrap = root.querySelector('[data-canvaspick]');
  var swWrap = canvasWrap ? canvasWrap.querySelector('.hsp-canvas-swatches') : null;

  function applyPalette() {
    var pal = PALETTES[curPalette];
    if (!pal) return;
    if (bgLayer) bgLayer.style.background = pal.bg;
    // Encre de signature par palette (fonds sombres -> crème), défaut = ink du design.
    if (sigEl) sigEl.setAttribute('fill', pal.ink || INK);
    if (baseImg && CANVAS_BY_PALETTE[curPalette]) baseImg.src = CANVAS_BY_PALETTE[curPalette];
    if (swWrap) {
      swWrap.querySelectorAll('.hsp-canvas-swatch').forEach(function (b) {
        var on = b.getAttribute('data-pal') === curPalette;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
  }
  function selectPalette(id) {
    if (!PALETTES[id] || !CANVAS_BY_PALETTE[id]) return;
    curPalette = id;
    applyPalette();
  }
  (function buildPaletteSwatches() {
    if (!swWrap || !canvasWrap) return;
    var usable = (N.palettes || []).filter(function (p) { return p && CANVAS_BY_PALETTE[p.id]; });
    if (usable.length < 2) { applyPalette(); return; }
    usable.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hsp-swatch hsp-canvas-swatch';
      b.setAttribute('data-pal', p.id);
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.setAttribute('title', p.label);
      b.setAttribute('aria-label', p.label);
      // La feuille lit var(--cs) — surtout pas --sw.
      b.style.setProperty('--cs', p.bg);
      b.addEventListener('click', function () { selectPalette(p.id); });
      swWrap.appendChild(b);
    });
    canvasWrap.hidden = false;
    applyPalette();
  })();

  // =========================================================================
  // 6. Toggle de variante douce (ex. garçon / fille) — pilote la palette
  //    par défaut + les exemples estompés. Entièrement déclaratif.
  // =========================================================================
  function normalizeGenders(g) {
    if (!g || typeof g !== 'object') return null;
    var opts = [];
    function mk(value, o) {
      return {
        value: String(value),
        label: String((o && o.label) || value),
        palette: (o && o.palette) ? String(o.palette) : '',
        samples: (o && o.samples && typeof o.samples === 'object') ? o.samples : null
      };
    }
    if (Array.isArray(g.options)) {
      g.options.forEach(function (o) { if (o && o.value) opts.push(mk(o.value, o)); });
    } else {
      // Tolérance : forme "objet" héritée des manifests naissance
      // ({ garcon: {...}, fille: {...} }) — parcourue génériquement.
      Object.keys(g).forEach(function (k) {
        if (k === 'label' || k === 'property' || k === 'options') return;
        if (g[k] && typeof g[k] === 'object') opts.push(mk(k, g[k]));
      });
    }
    if (opts.length < 2) return null;
    return {
      label: g.label ? String(g.label) : 'C\'est…',
      property: g.property ? String(g.property) : 'Sexe',
      options: opts
    };
  }

  var GENDER = normalizeGenders(N.genders);
  var genderLabel = '';
  var genderWrap = form.querySelector('[data-gender]');
  var genderInput = form.querySelector('[data-gender-input]');
  var genderToggle = form.querySelector('.hsp-gender-toggle');
  var genderTitle = form.querySelector('[data-gender-title]');

  if (GENDER && genderWrap && genderToggle) {
    if (genderTitle) genderTitle.textContent = GENDER.label;
    genderToggle.setAttribute('aria-label', GENDER.label);
    if (genderInput) genderInput.name = 'properties[' + GENDER.property + ']';
    GENDER.options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hsp-gender-btn';
      btn.setAttribute('data-gender-value', opt.value);
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.textContent = opt.label;
      btn.addEventListener('click', function () {
        genderLabel = opt.label;
        genderToggle.querySelectorAll('.hsp-gender-btn').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (genderInput) genderInput.value = opt.label;
        if (opt.samples) {
          Object.keys(opt.samples).forEach(function (k) {
            var val = String(opt.samples[k]);
            sampleOverride[k] = val;
            var el = inputByKey[k];
            var f = FIELD_BY_KEY[k];
            if (el && f && f.type === 'text') el.placeholder = 'Ex. ' + val;
          });
        }
        if (opt.palette) selectPalette(opt.palette);
        render();
      });
      genderToggle.appendChild(btn);
    });
    genderWrap.hidden = false;
  }

  // =========================================================================
  // 7. Variantes / prix / upsells / watermark — identiques à poster-naissance
  // =========================================================================
  var hiddenVariant = form.querySelector('[data-variant-id]');
  var priceNowEl    = root.querySelector('[data-price-now]');
  var btnTotalEl    = form.querySelector('[data-btn-total]');
  var addBtn        = form.querySelector('.hsp-add-to-cart');

  var noWatermark = false;
  var watermarkBtn = form.querySelector('[data-watermark-btn]');
  function applyWatermark() {
    if (sigEl) sigEl.style.display = noWatermark ? 'none' : '';
    if (watermarkBtn) watermarkBtn.setAttribute('aria-pressed', noWatermark ? 'true' : 'false');
  }
  if (watermarkBtn) {
    watermarkBtn.addEventListener('click', function () {
      noWatermark = !noWatermark;
      applyWatermark();
      updateTotal();
    });
  }

  var sel = { 1: null, 2: null };
  form.querySelectorAll('.hsp-chip.is-active').forEach(function (chip) {
    sel[chip.getAttribute('data-opt')] = chip.getAttribute('data-value');
  });
  var lastPaperFormat = sel['1'];

  var frameEl = root.querySelector('[data-frame]');
  function cadreToState(label) {
    var v = (label || '').toLowerCase();
    if (v.indexOf('noir') !== -1) return 'noir';
    if (v.indexOf('bois') !== -1) return 'bois';
    return 'none';
  }
  function applyFrame() {
    if (frameEl) frameEl.setAttribute('data-cadre', window.hsDigitalMode ? 'none' : cadreToState(sel['2']));
  }
  applyFrame();

  var variantId = CFG.variantId;
  var variantPriceCents = CFG.variantPriceCents;

  var DIGITAL = window.HAPPILYSTORY_DIGITAL || null;
  var digitalChip = form.querySelector('[data-digital-chip]');
  if (DIGITAL && digitalChip) digitalChip.hidden = false;
  function isDigitalMode() { return sel['1'] === '__digital__'; }
  function applyDigitalUi() {
    window.hsDigitalMode = isDigitalMode();
    var cadreGroup = form.querySelector('.hsp-variant-group[data-option-index="2"]');
    if (cadreGroup) cadreGroup.style.display = window.hsDigitalMode ? 'none' : '';
    applyFrame();
    document.querySelectorAll('.hs-upsell[data-key="digital"], .hs-upsell[data-key="replique"], .hs-upsell[data-key="carte"]').forEach(function (card) {
      card.style.display = window.hsDigitalMode ? 'none' : '';
      if (window.hsDigitalMode && card.classList.contains('is-selected')) {
        card.classList.remove('is-selected');
        card.querySelectorAll('.hs-upsell__pill').forEach(function (p) {
          var isNo = p.getAttribute('data-choice') === 'no';
          p.classList.toggle('is-active', isNo);
          p.setAttribute('aria-pressed', isNo ? 'true' : 'false');
        });
        var ex = card.querySelector('[data-extra-for]');
        if (ex) ex.hidden = true;
      }
    });
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function findVariant() {
    var fmt = sel['1'], cad = sel['2'];
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      var okF = (fmt == null) || (v.format === fmt);
      var okC = (cad == null) || (v.cadre === cad);
      if (okF && okC) return v;
    }
    return null;
  }

  function upsellsTotalCents() {
    var sum = 0;
    document.querySelectorAll('.hs-upsell.is-selected').forEach(function (card) {
      var p = parseFloat(card.getAttribute('data-price'));
      if (!isNaN(p)) sum += Math.round(p * 100);
    });
    return sum;
  }

  function updateTotal() {
    var total = variantPriceCents + upsellsTotalCents();
    if (noWatermark) total += WATERMARK_PRICE_CENTS;
    if (btnTotalEl) btnTotalEl.textContent = money(total);
  }

  function applyVariant() {
    if (isDigitalMode() && DIGITAL) {
      variantId = DIGITAL.variantId;
      variantPriceCents = DIGITAL.priceCents;
      if (hiddenVariant) hiddenVariant.value = DIGITAL.variantId;
      if (priceNowEl) priceNowEl.textContent = money(DIGITAL.priceCents);
      updateTotal();
      return;
    }
    var v = findVariant();
    if (v) {
      variantId = v.id;
      variantPriceCents = v.price;
      if (hiddenVariant) hiddenVariant.value = v.id;
      if (priceNowEl) priceNowEl.textContent = money(v.price);
    }
    updateTotal();
  }

  // Sous-prix des puces : prix TOTAL de la variante croisée (pattern sportsndeco).
  function refreshChipPrices() {
    form.querySelectorAll('.hsp-chip').forEach(function (chip) {
      var priceEl = chip.querySelector('.hsp-chip__price');
      if (!priceEl) return;
      var val = chip.getAttribute('data-value');
      if (val === '__digital__') {
        if (DIGITAL) priceEl.textContent = money(DIGITAL.priceCents);
        return;
      }
      var isFormat = chip.getAttribute('data-opt') === '1';
      var fmt = isFormat ? val : (lastPaperFormat || sel['1']);
      var cad = isFormat ? sel['2'] : val;
      for (var i = 0; i < VARIANTS.length; i++) {
        var v = VARIANTS[i];
        if ((fmt == null || v.format === fmt) && (cad == null || v.cadre === cad)) {
          priceEl.textContent = money(v.price);
          return;
        }
      }
    });
  }

  form.querySelectorAll('.hsp-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var opt = chip.getAttribute('data-opt');
      var val = chip.getAttribute('data-value');
      sel[opt] = val;
      if (opt === '1' && val !== '__digital__') lastPaperFormat = val;
      chip.closest('.hsp-chips').querySelectorAll('.hsp-chip').forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      applyVariant();
      refreshChipPrices();
      if (opt === '1') applyDigitalUi();
      if (opt === '2') applyFrame();
    });
  });
  refreshChipPrices();

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.hs-upsell__pill')) {
      setTimeout(updateTotal, 0);
    }
  });

  applyWatermark();
  updateTotal();
  updateAllCounts();
  render();

  // =========================================================================
  // 8. Submit — MEME payload print que poster-naissance
  // =========================================================================
  var HAS_REQUIRED = FIELDS.some(function (f) { return f.required; });

  // Renvoie le premier <input> fautif (obligatoire vide, ou valeur hors bornes
  // déclarées), sinon null. Si AUCUN champ n'est marqué required, on refuse au
  // moins le formulaire entièrement vide (une affiche sans texte = litige).
  function firstInvalidInput() {
    for (var i = 0; i < FIELDS.length; i++) {
      var f = FIELDS[i], el = inputByKey[f.key];
      if (!el) continue;
      var raw = String(el.value || '').trim();
      if (f.required && !raw) return el;
      if (raw && typeof el.checkValidity === 'function' && !el.checkValidity()) return el;
    }
    if (!HAS_REQUIRED) {
      var anyFilled = FIELDS.some(function (f2) {
        var e2 = inputByKey[f2.key];
        return e2 && String(e2.value || '').trim();
      });
      if (!anyFilled) return inputByKey[FIELDS[0].key] || null;
    }
    return null;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var bad = firstInvalidInput();
    if (bad) {
      bad.focus();
      form.classList.add('hsp-form--invalid');
      return;
    }
    form.classList.remove('hsp-form--invalid');
    render(); // fit final avant capture des sizes

    var v = findVariant();
    var pal = PALETTES[curPalette] || {};

    // ---------- Properties visibles client ----------
    // Libellé DECLARE dans fields (properties["Plat préféré"] = "Lasagnes"),
    // jamais la clé technique.
    var properties = {};
    FIELDS.forEach(function (f) {
      var val = slotValue(f.key);
      if (val) properties[f.label] = val;
    });
    if (GENDER && genderLabel) properties[GENDER.property] = genderLabel;
    if (pal.label) properties['Couleur'] = pal.label;

    // ---------- Properties cachées pour le Worker print ----------
    // _hs_grid = les slots renseignés uniquement (un support vide reste vide).
    var gridItems = [];
    for (var i = 0; i < slotEls.length; i++) {
      var entry = slotEls[i];
      var s = entry.def;
      var val = slotValue(s.key);
      if (!val) continue;
      gridItems.push({
        x: s.x + (entry.dx || 0), y: s.y,
        size: entry.fitted || s.size,
        text: val,
        anchor: s.anchor || 'middle',
        family: s.family || 'Caveat',
        fill: s.fill || INK
      });
    }

    properties['_hs_mode']       = 'grid';
    properties['_hs_canvas_url'] = CANVAS_BY_PALETTE[curPalette] || '';
    properties['_hs_bg']         = pal.bg || '#FBF6EE';
    properties['_hs_ink']        = pal.ink || INK;
    properties['_hs_grid']       = JSON.stringify(gridItems);
    properties['_hs_sig_y']      = SIG_Y;
    properties['_hs_format']     = (v && v.format) || sel['1'] || '';
    properties['_hs_cadre']      = (v && v.cadre)  || sel['2'] || '';
    // Palette d'illustrations du design (c1..c6 + bg/ink) : inerte tant qu'il n'y
    // a ni motif ni picto perso, mais attendue par le worker le jour où ces
    // options arrivent sur cette gamme. Envoyée seulement si le manifest la déclare.
    if (N.palette && typeof N.palette === 'object') {
      properties['_hs_palette'] = JSON.stringify({
        c1: N.palette.c1, c2: N.palette.c2, c3: N.palette.c3,
        c4: N.palette.c4, c5: N.palette.c5, c6: N.palette.c6,
        bg: pal.bg || N.bg || '#FBF6EE',
        ink: pal.ink || INK
      });
    }
    if (isDigitalMode() && DIGITAL) {
      properties['_hs_format'] = 'numerique';
      properties['_hs_cadre']  = 'sans';
      properties['Format']     = 'Fichier numérique HD';
      properties['Modèle']     = CFG.productTitle || document.title;
    }

    if (noWatermark) {
      properties['_hs_nowatermark'] = 'true';
      properties['Sans mention happilystory'] = 'Oui';
    }

    var _hsGrp = (typeof window.hsNewGroupToken === 'function') ? window.hsNewGroupToken() : null;
    if (_hsGrp) properties['_hs_group'] = _hsGrp;
    var mainItem = { id: variantId, quantity: 1, properties: properties };
    var items = [mainItem];
    if (typeof window.hsCollectUpsells === 'function') {
      items = items.concat(window.hsCollectUpsells(_hsGrp));
    }
    if (noWatermark && WATERMARK_VARIANT_ID) {
      items.push({ id: WATERMARK_VARIANT_ID, quantity: 1, properties: { _hs_for: 'watermark' } });
    }

    if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d && d.description || 'Erreur panier'); });
        return r.json();
      })
      .then(function () {
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
        if (window.snRefreshCartDrawer && window.snOpenCartDrawer) {
          Promise.resolve(window.snRefreshCartDrawer()).then(function () { window.snOpenCartDrawer(); });
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
        form.classList.add('hsp-form--invalid');
        if (window.console) console.error('[happilystory] add to cart failed:', err);
        alert('Désolé, l\'ajout au panier a échoué. Merci de réessayer.');
      });
  });
})();
